import { render, staticRenderFns } from "./CustomerChat.vue?vue&type=template&id=29e450f7"
import script from "./CustomerChat.vue?vue&type=script&lang=js"
export * from "./CustomerChat.vue?vue&type=script&lang=js"
import style0 from "./CustomerChat.vue?vue&type=style&index=0&id=29e450f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports